import { render } from "./PlatFormMenu.vue?vue&type=template&id=2f51d3b2&scoped=true"
import script from "./PlatFormMenu.vue?vue&type=script&lang=js"
export * from "./PlatFormMenu.vue?vue&type=script&lang=js"

import "./PlatFormMenu.vue?vue&type=style&index=0&id=2f51d3b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f51d3b2"]])

export default __exports__